function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWedge5Full = function SvgWedge5Full(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    viewBox: "0 0 100 100"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M28.464 19.138c-2.102-3.639-6.415-4.367-9.569-1.59 0 0-4.07 3.558-7.493 9.488-3.315 5.741-4.34 10.647-4.34 10.647-.863 4.124 1.887 7.493 6.092 7.493H35.85c4.205 0 5.93-2.965 3.827-6.631L28.464 19.138z"
  }));
};
export default SvgWedge5Full;